import { Routes, Route } from "react-router-dom";
import WebDm from "./Pages/WebDm";
import "./index.css";
import Settings from "./Pages/Settings";
import Account from "./Pages/Account";
import ProtectedRoutes from "./lib/ProctedRoutes";
import SignUp from "./Pages/SignUp";
import Home from "./Pages/Home";
import Login from "./Pages/Login";
import ForgotPassword from "./Pages/ForgotPassword";
import Chatbot from "./utils/Chatbot";
import PaymentPage from "./Pages/PaymentPage";
import AiSubFlow from "./Pages/AiSubFlow";
import ContactList from "./Pages/ContactList";
import ProductList from "./Pages/ProductList";
import { v4 as uuid } from "uuid";
import Cookies from "universal-cookie";
import { useEffect, useState } from "react";
import { useGetUserSubscription } from "./hooks/payment";
import { useAuth } from "./hooks/auth";
import DataSettings from "./Pages/DataSettings";
import InstagramDm from "./Pages/InstagramDm";
import FacebookMessengerDm from "./Pages/FacebookMessengerDm";
import Calendar from "./Pages/Calendar";
import ShopifyProduct from "./Pages/ShopifyProduct";
import ProductCard from "./Components/ProductCard";
import CallbackPage from "./Pages/CallbackPage";
import Loader from "./Components/Loader";
import Mail from "./Pages/Mail";
import LunaForYou from "./Pages/LunaForYou";
import MyComponent from "./Pages/MyComponent";
import EditChat from "./Pages/EditChat";


function App() {
  
  const {} = useAuth();
  const { subscriptionLoading } = useGetUserSubscription();
  const unique_id = uuid();
  const cookies = new Cookies();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!cookies.get("uuid")) {
      cookies.set("uuid", unique_id, { path: "/" });
    }
    
    // Set a delay before setting loading to false
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);  

    return () => clearTimeout(timer);  // This clears the timer when the component unmounts

  }, []);
  

  return (
    <div>
      {loading ? <Loader /> : (

        <Routes>
        <Route path="/chatapp" element={<Chatbot />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/checkout" element={<PaymentPage />} />
        <Route path="/oauth/callback" element={<CallbackPage />} />
        
        {/* Protected routes */}
        
        <Route
          element={
            <ProtectedRoutes subscriptionLoading={subscriptionLoading} />
          }
          >
          <Route path="/" element={<Home />} />
          <Route path="/edit-chat" element={<EditChat />} />
          <Route path="/scrap" element={<MyComponent />} />
          <Route path="/luna-for-you" element={<LunaForYou />} />
          <Route path="/visual-viewer" element={<ProductCard />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/ai-customisation-flow" element={<AiSubFlow />} />
          <Route path="/contact-list" element={<ContactList />} />
          <Route path="/product-list" element={<ProductList />} />
          <Route path="/shopify-product-list" element={<ShopifyProduct />} />
          <Route path="/web-dm" element={<WebDm />} />
          <Route path="/instagram-dm" element={<InstagramDm />} />
          <Route path="/facebook-dm" element={<FacebookMessengerDm />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/data-settings" element={<DataSettings />} />
          <Route path="/account" element={<Account />} />
        </Route>
      </Routes>
          )}
    </div>
  );
}

export default App;
